<template>
  <div data-scrolling-animations="true">
    <!-- ========================== -->
    <!-- HOME - HEADER -->
    <!-- ========================== -->
    <section class="top-header home-header with-bottom-effect transparent-effect dark">
      <div class="bottom-effect"></div>
      <div class="header-container">
        <slider></slider>
      </div>
      <!--./container-->
    </section>

    <!-- ========================== -->
    <!-- HOME - VIDEO SECTION -->
    <!-- ========================== -->
    <section class="features-section">
      <div class="container">
        <div class="section-heading">
          <div class="section-title">联盛纸业&联盛浆纸</div>
        </div>
        <div class="section-subtitle">Simple Efficient Excellent</div>
        <div class="design-arrow"></div>
      </div>
      <div class="container">
        <p></p>
        <div class="embed-responsive embed-responsive-16by9">
          <video width="320" height="240" controls="controls">
            <source src="../assets/video/liansheng-trailer.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
    </section>

    <!-- ========================== -->
    <!-- HOME - AREAS OF EXPERTISE-->
    <!-- ========================== -->
    <section class="features-section">
      <div class="container">
        <div class="design-arrow"></div>
      </div>
    </section>

    <!-- ========================== -->
    <!-- HOME - ACHIEVEMENTS -->
    <!-- ========================== -->
    <section class="achievements-section with-bottom-effect dark dark-strong">
      <div class="bottom-effect"></div>
      <div class="container dark-content">
        <div class="row list-achieve">
          <div class="col-md-3 col-sm-3 col-xs-6 wow zoomIn" data-wow-delay="0.5s">
            <article>
              <div class="achieve-item">
                <div class="achieve-icon">
                  <span class="icon icon-Wallet"></span>
                </div>
                <div class="count">390+</div>
                <div class="name">产品数量</div>
              </div>
            </article>
          </div>
          <div class="col-md-3 col-sm-3 col-xs-6 wow zoomIn" data-wow-delay="1.5s">
            <article>
              <div class="achieve-item">
                <div class="achieve-icon">
                  <span class="icon icon-Cup"></span>
                </div>
                <div class="count">180+</div>
                <div class="name">获得荣誉</div>
              </div>
            </article>
          </div>
          <div class="col-md-3 col-sm-3 col-xs-6 wow zoomIn" data-wow-delay="2.5s">
            <article>
              <div class="achieve-item">
                <div class="achieve-icon">
                  <span class="icon icon-Like"></span>
                </div>
                <div class="count">7000+</div>
                <div class="name">合作伙伴</div>
              </div>
            </article>
          </div>
          <div class="col-md-3 col-sm-3 col-xs-6 wow zoomIn" data-wow-delay="3.5s">
            <article>
              <div class="achieve-item">
                <div class="achieve-icon">
                  <span class="icon icon-Users"></span>
                </div>
                <div class="count">7000+</div>
                <div class="name">员工数量</div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>

    <!-- ========================== -->
    <!-- HOME - LATEST WORKS -->
    <!-- ========================== -->
    <section class="latest-works-section clearfix">
      <div class="container">
        <div class="section-heading">
          <!-- <div class="section-title">联盛照片墙</div>
          <div class="section-subtitle">LianSheng Culture</div>
          <div class="design-arrow"></div> -->
        </div>
      </div>

      <div class="scroll-pane">
        <div class="scroll-content">
          <div class="scroll-content-item">
            <a class="fancybox">
              <img src="../assets/img/background-1.png" alt="" />
            </a>
            <div class="name">联盛风光</div>
          </div>
          <div class="scroll-content-item">
            <a class="fancybox">
              <img src="../assets/img/sections/home-top-background-4.jpg" alt="" />
            </a>
            <div class="name">漳浦基地</div>
          </div>
          <div class="scroll-content-item">
            <a class="fancybox">
              <img src="../assets/img/harmony-home/fc-1.jpg" alt="" />
            </a>
            <div class="name">食堂美食</div>
          </div>
          <div class="scroll-content-item">
            <a class="fancybox">
              <img src="../assets/img/employee-care/yggh-1.jpg" alt="" />
            </a>
            <div class="name">员工关怀</div>
          </div>
          <div class="scroll-content-item">
            <a class="fancybox">
              <img src="../assets/img/harmony-home/fc-2.jpg" alt="" />
            </a>
            <div class="name">食堂美食</div>
          </div>
          <div class="scroll-content-item">
            <a class="fancybox">
              <img src="../assets/img/harmony-home/fc-3.jpg" alt="" />
            </a>
            <div class="name">食堂美食</div>
          </div>
          <div class="scroll-content-item">
            <a class="fancybox">
              <img src="../assets/img/harmony-home/st-1.jpg" alt="" />
            </a>
            <div class="name">食堂一览</div>
          </div>
          <div class="scroll-content-item">
            <a class="fancybox">
              <img src="../assets/img/img3.jpg" alt="" />
            </a>
            <div class="name">联盛纸业晚会</div>
          </div>
          <div class="scroll-content-item">
            <a class="fancybox">
              <img src="../assets/img/img4.jpg" alt="" />
            </a>
            <div class="name">龙海宿舍</div>
          </div>
          <div class="scroll-content-item">
            <a class="fancybox">
              <img src="../assets/img/img1.jpg" alt="" />
            </a>
            <div class="name">龙海基地</div>
          </div>
          <div class="scroll-content-item">
            <a class="fancybox">
              <img src="../assets/img/img2.jpg" alt="" />
            </a>
            <div class="name">龙海办公区</div>
          </div>
        </div>
        <!-- 滚动条 -->
        <div class="scroll-bar-wrap">
          <div class="scroll-bar"></div>
        </div>
      </div>
    </section>

    <!-- ========================== -->
    <!-- HOME - BROWSERS  -->
    <!-- ========================== -->
    <section class="browsers-section with-bottom-effect">
      <div class="bottom-effect"></div>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <img src="../assets/img/browsers-image.png" alt=" " class="img-responsive" />
          </div>
        </div>
      </div>
    </section>

    <!-- ========================== -->
    <!-- HOME - SERVICES  -->
    <!-- ========================== -->
    <!-- <section class="services-section">
      <div class="container">
        <div class="section-heading">
          <div class="section-title">待遇福利与工作环境</div>
          <div class="section-subtitle">PAYMENT AND ENVIRONMENT</div>
          <div class="design-arrow"></div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-4 col-xs-4">
            <div class="service-item">
              <div class="media-left">
                <div class="wrap-service-icon">
                  <div class="service-icon">
                    <span class="icon icon-Flag"></span>
                  </div>
                </div>
              </div>
              <div class="media-body">
                <h5>薪酬收入</h5>
                <p><em>payments</em></p>
                <p>以贡献定报酬，品责任定待遇</p>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-4">
            <div class="service-item">
              <div class="media-left">
                <div class="wrap-service-icon">
                  <div class="service-icon">
                    <span class="icon icon-Carioca"></span>
                  </div>
                </div>
              </div>
              <div class="media-body">
                <h5>社会保险</h5>
                <p><em>insurance</em></p>
                <p>依法办理社会保险</p>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-4">
            <div class="service-item">
              <div class="media-left">
                <div class="wrap-service-icon">
                  <div class="service-icon">
                    <span class="icon icon-Planet"></span>
                  </div>
                </div>
              </div>
              <div class="media-body">
                <h5>学习助力</h5>
                <p><em>learning</em></p>
                <p>提供各种教育培训</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="services-divider">
            <div class="col-md-4 col-sm-4 col-xs-4"></div>
            <div class="col-md-4 col-sm-4 col-xs-4"></div>
            <div class="col-md-4 col-sm-4 col-xs-4"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-4 col-xs-4">
            <div class="service-item">
              <div class="media-left">
                <div class="wrap-service-icon">
                  <div class="service-icon">
                    <span class="icon icon-Folder"></span>
                  </div>
                </div>
              </div>
              <div class="media-body">
                <h5>免费宿舍</h5>
                <p><em>free dormitory</em></p>
                <p>免费宿舍空调热水,WIFI全覆盖</p>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-4">
            <div class="service-item">
              <div class="media-left">
                <div class="wrap-service-icon">
                  <div class="service-icon">
                    <span class="icon icon-Layers"></span>
                  </div>
                </div>
              </div>
              <div class="media-body">
                <h5>膳食服务</h5>
                <p><em>delicious food</em></p>
                <p>品种齐全价格优惠</p>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-4">
            <div class="service-item">
              <div class="media-left">
                <div class="wrap-service-icon">
                  <div class="service-icon">
                    <span class="icon icon-DesktopMonitor"></span>
                  </div>
                </div>
              </div>
              <div class="media-body">
                <h5>带薪休假</h5>
                <p><em>holiday with payment</em></p>
                <p>享受法定假与年休假</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- ========================== -->
    <!-- REVIEWS SECTION -->
    <!-- ========================== -->
    <section class="reviews-section">
      <div class="container">
        <div class="section-heading">
          <div class="section-title">人才政策</div>
          <div class="section-subtitle">
            Enterprise Personnel Management and Talent policy system
          </div>
          <div class="design-arrow"></div>
        </div>
      </div>
      <div class="container">
        <div class="reviews-slider enable-owl-carousel" data-single-item="true">
          <div class="slide-item">
            <div class="media-left">
              <div class="image-block">
                <img src="../assets/img/review-img1.png" alt="" />
              </div>
            </div>
            <div class="media-body">
              <div class="description-block">
                <div class="name">
                  <span>人才政策</span>
                  <em>person policy</em>
                </div>
                <div class="review">
                  <em>联盛人始终秉承“朴素务实、忠诚团结、岗位奉献、勇于开拓”的企业精神，坚持“重视人才，关注员工”的企业宗旨，按照“客户第一、诚信至上”的经营理念和“简单、高效、卓越”的管理理念扎扎实实推进各项经营管理工作。
                    “员工与公司共同成长”的观念使联盛人与企业牢牢联结在一起，已形成了一支生命力旺盛的忠诚的企业团队，联盛纸业也走出了一条具有自身特色的企业文化发展道路。
                    重视人才，关注员工。只要您是造纸电力行业的人才，我们诚邀您加入联盛纸业大家庭，与公司共同成长，铸就公司的成功辉煌，铺就您成功的职业道路。</em>
                </div>
              </div>
            </div>
          </div>
          <div class="slide-item">
            <div class="media-left">
              <div class="image-block">
                <img src="../assets/img/review-img2.png" alt="" />
              </div>
            </div>
            <div class="media-body">
              <div class="description-block">
                <div class="name">
                  <span>人才理念</span>
                  <em>person value</em>
                </div>
                <div class="review">
                  <em>基本价值观：坚持以人为本——员工与企业共同成长；
                    坚持以市场为导向——致力于客户利益最大化；
                    坚持学习创新——盯住标杆，稳步前进；
                    坚持科学发展——追求企业与环境和谐的可持续发展。
                    用人之道：名至实归
                    ，更重实际；德才兼备，唯才是举；抓大放小，不拘小节。</em>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ========================== -->
    <!-- BUY SECTION -->
    <!-- ========================== -->
    <section class="buy-section with-icon">
      <div class="section-icon"><span class="icon icon-Heart"></span></div>
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-1 col-sm-9 wow fadeInLeft">
            <div class="section-text">
              <div class="vcenter like">
                <span class="icon icon-Briefcase"></span>
              </div>
              <div class="buy-text vcenter">
                <div class="top-text">一 起 加 入 联 盛 大 家 庭 吧 ！</div>
                <p></p>
                <div class="bottom-text">Join to LianSheng Family</div>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-3 wow fadeInRight">
            <a href="/recruitment/contactus" class="btn btn-info">加 入 我 们</a>
          </div>
        </div>
      </div>
    </section>

    <!-- ========================== -->
    <!-- HOME - SLIDER -->
    <!-- ========================== -->
    <section class="slider-section dark dark-strong with-bottom-effect">
      <div class="bottom-effect"></div>
      <div class="dark-content">
        <div class="wrap-section-slider enable-owl-carousel" data-single-item="true">
          <div class="slide-item">
            <div class="slider-title">
              联盛纸业
              <img class="logo-free" src="../assets/img/logo-free.png" />
              联盛浆纸
            </div>
            <p class="large">
              公司于2023年7月成功通过了 FSC-COC 产销监管链认证，这一里程碑事件标志着我们在可持续发展和环保领域迈出了坚实的步伐。
            </p>
            <div class="time">2023年07月</div>
          </div>
          <div class="slide-item">
            <div class="slider-title">
              联盛纸业
              <img class="logo-free" src="../assets/img/logo-free.png" />
              联盛浆纸
            </div>
            <p class="large">
              公司于2023年12月通过认证的体系为“质量、环境、职业健康安全和社会责任管理体系”，
              标志着我们在质量管理、环境管理、职业健康安全管理和社会责任管理方面取得了显著的进步。
            </p>
            <div class="time">2023年12月</div>
          </div>
          <div class="slide-item">
            <div class="slider-title">
              联盛纸业
              <img class="logo-free" src="../assets/img/logo-free.png" />
              联盛浆纸
            </div>
            <p class="large">
              我司于2024年5月获得了白卡纸碳足迹核查声明书，标志着我们在环保和可持续发展方面取得了重要进展。
            </p>
            <div class="time">2024年5月</div>
          </div>
        </div>
      </div>
    </section>

    <!-- ========================== -->
    <!-- HOME - CLIENTS -->
    <!-- ========================== -->
    <section class="clients-section clearfix">
      <div class="container">
        <div class="section-heading wow fadeInDown">
          <div class="section-title">我们的客户</div>
          <div class="section-subtitle">trusted clients</div>
          <div class="design-arrow"></div>
        </div>
      </div>
      <div class="container">
        <div class="list-clients">
          <div class="client-item wow fadeInLeft">
            <img src="../assets/img/partners/clients_jianfa.png" alt="" />
          </div>
          <div class="client-item wow fadeInLeft">
            <img src="../assets/img/partners/clients_itg.png" alt="" />
          </div>
          <div class="client-item wow fadeInRight">
            <img src="../assets/img/partners/clients_hexing.png" alt="" />
          </div>
          <div class="client-item wow fadeInRight">
            <img src="../assets/img/partners/clients_qirun.png" alt="" />
          </div>
          <div class="client-item wow fadeInRight">
            <img src="../assets/img/partners/clients_shengyuan.png" alt="" />
          </div>
          <div class="client-item wow fadeInRight">
            <img src="../assets/img/partners/clients_wangfeng.png" alt="" />
          </div>
          <div class="client-item wow fadeInRight">
            <img src="../assets/img/partners/clients_xiangyuan.png" alt="" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Slider from '../components/Slider.vue';

export default {
  components: { Slider },
  name: 'home'
};

</script>


// WEBPACK FOOTER //
// src/view/Home.vue